export const updateSearchResults = () => {
    console.log("searching medicine");
    function updateSearchResults(inp) {
        inp.addEventListener("input", function (e) {
            var term = this.value;
            console.log(term);
            fetch(`umbraco/surface/Autocomplete/SearchMedicine?term=${term}&pageSize=25&pageIndex=1`)
                .then(response => response.json())
                .then(data => {
                    // Clear existing search results
                    const searchResultsList = document.querySelector('.med-searchresult-list');
                    searchResultsList.innerHTML = '';
                    console.log(data);
                    //// Update total search hits
                    //const totalSearchHits = document.querySelector('h2');
                    //totalSearchHits.textContent = `${data.totalSearchHits} träffar`;

                    // Populate search results 
                    if (data.displaySearchResults && data.searchResults.length > 0) {
                        var resultCounter = 1;
                        data.searchResults.forEach(result => {
                            const li = document.createElement("li");
                            li.classList.add("med-searchresult-list__item");

                            // Create the link and the url to individual pages
                            const a = document.createElement("a");
                            a.classList.add("med-searchresult-list__link");
                            a.href = result.medicinalResultUrl;

                            var medBaseClassname = "med-searchresult-list__resultpart";
                                 
                            // Med-name
                            const medName = document.createElement("strong");
                            medName.classList.add(medBaseClassname);
                            medName.classList.add(medBaseClassname+"--tradename");
                            medName.textContent = result.tradeName;
                            medName.id = "medResultName_" + resultCounter;
                            medName.setAttribute("aria-labeledby", medName.id + " medSearchLabelName");
                            
                            // Med-strength
                            const strengthName = document.createElement("p");
                            strengthName.classList.add(medBaseClassname);
                            strengthName.classList.add(medBaseClassname + "--strength");
                            strengthName.textContent = result.strength;
                            strengthName.id = "medResultStrength_" + resultCounter;
                            strengthName.setAttribute("aria-labeledby", strengthName.id + " medSearchLabelStrength");

                            // Med-substances
                            const formattedSubstanceName = result.substanceName.join(", ");
                            const substanceName = document.createElement("p");
                            substanceName.classList.add(medBaseClassname);
                            substanceName.classList.add(medBaseClassname + "--substancename");
                            substanceName.textContent = formattedSubstanceName;
                            substanceName.id = "medesultSubstancename_" + resultCounter;
                            substanceName.setAttribute("aria-labeledby", substanceName.id + " medSearchLabelSubstances");

                            // Med-doseform
                            const doseName = document.createElement("p");
                            doseName.classList.add(medBaseClassname);
                            doseName.classList.add(medBaseClassname + "--dose");
                            doseName.textContent = result.doseForm;
                            doseName.id = "medResultDose_" + resultCounter;
                            doseName.setAttribute("aria-labeledby", doseName.id + " medSearchLabelDose");

                            // Med-dopinggroup
                            /*const wadaObj = document.createElement("object")
                            const wadaName = document.createElement("a");

                            wadaObj.classList.add(medBaseClassname);
                            wadaObj.classList.add(medBaseClassname + "--wada");
                            wadaName.classList.add(medBaseClassname + "link");
                            wadaName.classList.add(medBaseClassname + "--wadalink");
                            wadaName.textContent = result.wadaName;
                            wadaName.href = result.wadaUrl;
                            wadaName.id = "medResultWada_" + resultCounter;
                            wadaName.setAttribute("aria-labeledby", wadaName.id + " medSearchLabelWada");
                            wadaObj.appendChild(wadaName);*/

                            // Link-indicator
                            const linkIndicator = document.createElement("div");
                            linkIndicator.classList.add(medBaseClassname);
                            linkIndicator.classList.add(medBaseClassname + "--linkindicator");
                            linkIndicator.innerHTML = "<span>➜</span>";
                            linkIndicator.id = "linkIndicator" + resultCounter;
                            linkIndicator.setAttribute("aria-labeledby", linkIndicator.id + " medSearchLabelLinkindicator");


                            // Add parts to link
                            a.appendChild(medName);
                            a.appendChild(strengthName);
                            a.appendChild(substanceName);
                            a.appendChild(doseName);
                            //a.appendChild(wadaObj);
                            a.appendChild(linkIndicator);

                            li.appendChild(a);
                            searchResultsList.appendChild(li);

                            resultCounter++;
                        });
                    } else if (data.noResult) {
                        searchResultsList.innerHTML = '<div class="med - search__no - result"><h3> Din sökning genererade inga träffar</h3><p>Kontrollera att du stavat rätt eller prova med något annat.</p></div>';
                    }

                    // Update pagination
                    const pagination = document.querySelector('.pagination');
                    pagination.innerHTML = '';
                    for (let i = 1; i <= data.nrOfPaging; i++) {
                        const li = document.createElement("li");
                        li.classList.add("page-item");

                        const a = document.createElement("a");
                        a.classList.add("page-link");
                        a.href = `?pageIndex=${i}`;
                        a.textContent = i;

                        li.appendChild(a);
                        pagination.appendChild(li);
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error(error);
                });
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        updateSearchResults(document.getElementById("searchTermOnSite"));
    });
};